import { widgetSetupSelector } from "../widgetSetupSelector";
import { RootState } from "../../../../store";

export const widgetSetupWidgetIdSelector = (
  state: RootState,
): string | undefined => {
  return widgetSetupSelector(state)?.id;
};
